<template>
  <router-view/>
</template>

<style>
*{
  padding: 0;
  margin: 0;
  font-size: 14px;
  /* color: #000000; */
  -webkit-tap-highlight-color: transparent;
}
body,ul,ol,li,p,h1,h2,h3,h4,h5,h6,form,fieldset,table,td,img,div,dl,dt,dd,input{
  margin: 0;
  padding: 0;
}
body{
  max-width: 750px;
  margin: 0 auto;
  font-family: Arial;
}
li{
  list-style:none;
}
a,a:hover,a:active{
  color: blue;
  text-decoration:none
}
img{
  display: block;
}
.flex{
  display: flex;
}
.jube{
  justify-content: space-between;
}
.jucen{
  justify-content: center;
}
.alcen{
  align-items: center;
}
.wrap{
  flex-wrap: wrap;
}
.main-back{
  padding-bottom: 1rem!important;
}
.yy {
  width: 100%;
  position: fixed;
  bottom:0;
  background: #fff;
  height: 17.0667vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #e8e8e8;
}
.yy .btn {
  height: 11.7333vw;
  line-height: 11.7333vw;
  background-image: linear-gradient(-45deg, #2E7BFF 0%, #4CA9FF 100%);
  width:92vw;
  border-radius: 1.8667vw;
  margin: 0 auto;
  font-size: 4vw;
  color: #FFFFFF;
  text-align: center;
  font-weight: bold;
}
.yy > img {
  width: 100%;
}
</style>
